import { render, staticRenderFns } from "./wxtzscoreschart.vue?vue&type=template&id=74cec5a6&scoped=true&"
import script from "./wxtzscoreschart.vue?vue&type=script&lang=js&"
export * from "./wxtzscoreschart.vue?vue&type=script&lang=js&"
import style0 from "./wxtzscoreschart.vue?vue&type=style&index=0&id=74cec5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cec5a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74cec5a6')) {
      api.createRecord('74cec5a6', component.options)
    } else {
      api.reload('74cec5a6', component.options)
    }
    module.hot.accept("./wxtzscoreschart.vue?vue&type=template&id=74cec5a6&scoped=true&", function () {
      api.rerender('74cec5a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxtzscoreschart.vue"
export default component.exports